import { z } from 'zod'

export const RequestFormSchema = z.object({
  email: z.string().email('Invalid email address').optional(),
  location: z.string().min(2, 'Location is required'),
  message: z.string().optional(),
  name: z.string().min(2, 'Must be at least 2 characters'),
  phone: z.string().min(7, 'Must be at least 7 characters'),
  time: z.string(),
})

export type RequestFormSchemaType = z.infer<typeof RequestFormSchema>
